import database from "./database";

globalThis.db = database;
